import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
  setValue(v: string): void;
}

export default function DeviceSearchField({ value, setValue }: Props) {
  const { t } = useTranslation();

  return (
    <TextField
      fullWidth
      size="small"
      type="text"
      value={value}
      onChange={v => setValue(v.currentTarget.value)}
      label={t("deviceFirmware.title")}
      placeholder={t("deviceFirmware.inptPlaceholder")}
    ></TextField>
  );
}
